export class SolApiRespPageInfo {
  constructor(
    public currentPage?: number,
    public sizePage?: number,
    public totalPages?: number,
    public totalItems?: number
  ) {}
}
